import { SvgIcon , SvgIconProps} from '@mui/material';
import './ccf-single-arrow-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfSingleArrowIconProps extends SvgIconProps {}

/**
 *
 * @param props -
 * @example
 * @returns
 */
export function CcfSingleArrowIcon(props: CcfSingleArrowIconProps) {
  return (
    <SvgIcon
      {...props}
      width="8"
      height="16"
      viewBox="0 0 8 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.226415 7.00497L6.64151 0.238806C6.9434 -0.079602 7.4717 -0.079602 7.77358 0.238806C8.07547 0.557214 8.07547 1.11443 7.77358 1.43284L1.73585 7.80099L7.77358 14.5672C8.07547 14.8856 8.07547 15.4428 7.77358 15.7612C7.4717 16.0796 6.9434 16.0796 6.64151 15.7612L0.226415 8.59702C1.40577e-08 8.35821 0 8.1194 0 7.8806C0 7.48259 0.0754717 7.16418 0.226415 7.00497Z"
        fill="black"
      />
    </SvgIcon>
  );
}

export default CcfSingleArrowIcon;
